// extracted by mini-css-extract-plugin
export var main = "layout-module--main--1X6Cv";
export var scrollLayout = "layout-module--scroll-Layout--ltAly";
export var layout = "layout-module--layout--BVXGa";
export var layoutContact = "layout-module--layout-contact--lUNpv";
export var layoutNews = "layout-module--layout-news--1yLSF";
export var layoutTitle = "layout-module--layout-title--1AzgF";
export var nav = "layout-module--nav--3Ui7Z";
export var active = "layout-module--active--1K8n1";
export var iconAudio = "layout-module--icon-audio--32ROs";